import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { BehaviorSubject, catchError, Observable, of, throwError } from "rxjs";

import { ApiConectateService } from "../../../../api/apiConectate";
import { QuestionList, SurveyResponse } from "../../../../models/survey.model";
import { SURVEY_CONSTANTS } from "./survey.constanst";
import { EnvironmentService } from "../../../../services/enviroment/environment.service";
import { SessionStorageService } from "../../../../services/session-storage/session-storage.service";
import { StateHandlerService } from "../../../../services/state-handler/state-handler.service";
import { UtilsService } from "../../../../services/utils/utils.service";
import { AsyncPipe, NgClass, NgStyle } from "@angular/common";
import { TranslatePipe } from "@ngx-translate/core";
import { FormsModule } from "@angular/forms";

@Component({
  standalone: true,
  imports: [
    AsyncPipe,
    NgStyle,
    NgClass,
    TranslatePipe,
    FormsModule
  ],
  selector: "sas-survey",
  templateUrl: "./survey.component.html",
  styleUrls: ["./survey.component.scss"],
})
export class SurveyComponent implements OnInit {
  maxLengthTextArea = 255;
  minLengthTextArea = 2;
  textAreaModel?: string;
  styleExp = "50%";
  currentStep: number = 1;
  canPassToNextQuestion?: boolean;
  steps: number = 0;
  loading = false;

  threeEmojis: any[] = [
    {
      icon: "icon-emoji-ko-off",
      iconOn: "icon-emoji-ko-on",
      value: 1,
      set: false,
    },
    {
      icon: "icon-emoji-neutral-off",
      iconOn: "icon-emoji-neutral-on",
      value: 2,
      set: false,
    },
    {
      icon: "icon-emoji-ok-off",
      iconOn: "icon-emoji-ok-on",
      value: 3,
      set: false,
    },
  ];

  fiveEmojis: any[] = [
    {
      icon: "icon-emoji-very-ko-off",
      iconOn: "icon-emoji-very-ko-on",
      value: 1,
      set: false,
    },
    {
      icon: "icon-emoji-ko-off",
      iconOn: "icon-emoji-ko-on",
      value: 2,
      set: false,
    },
    {
      icon: "icon-emoji-neutral-off",
      iconOn: "icon-emoji-neutral-on",
      value: 3,
      set: false,
    },
    {
      icon: "icon-emoji-ok-off",
      iconOn: "icon-emoji-ok-on",
      value: 4,
      set: false,
    },
    {
      icon: "icon-emoji-very-ok-off",
      iconOn: "icon-emoji-very-ok-on",
      value: 5,
      set: false,
    },
  ];

  questionList: QuestionList[] = [];
  isTwoQuestionsFormat = false;
  inputType = SURVEY_CONSTANTS.INPUTS_TYPE;
  surveyAnswers: SurveyResponse;
  private indexQuestion: number = 0;
  private idSurvey?: number;
  selectResponse: number | null = null;
  selectedRecommendOption: number | null = null;
  private _buttonVisible: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  preparedAnswers?: SurveyResponse;

  public get buttonVisible(): boolean {
    return this._buttonVisible.getValue();
  }
  public set buttonVisible(value: boolean) {
    this._buttonVisible.next(value);
  }

  get buttonVisible$(): Observable<boolean> {
    return this._buttonVisible.asObservable();
  }

  constructor(
    private readonly apiConectateServ: ApiConectateService,
    private readonly enviroment: EnvironmentService,
    private readonly sessionStorageSrv: SessionStorageService,
    private readonly stateHandlerSvc: StateHandlerService,
    private readonly changeDetector: ChangeDetectorRef,
    private readonly utilsService: UtilsService
  ) {
    this.surveyAnswers = this.resetSurvey();
  }

  resetSurvey() {
    return  {
      answers: [],
      connectionId: '',
      participantId: ''
    };
  }

  // tslint:disable:no-unused-expression
  ngOnInit(): void {
    this.stateHandlerSvc.set("intoRoomDisconnected", false);
    this.isTwoQuestionsFormat =
      this.enviroment.data?.features?.survey_two_questions_format;
    this.getSurveyQuestions();
  }

  // Method that get the previous question
  previousQuestion(): void {
    this.indexQuestion--;
    this.indexQuestion >= 0 ? this.currentStep-- : (this.indexQuestion = 0);
    // this.canPassToNextQuestion = this.areRespondedNextQuestion(this.questionList);
  }

  // Method that get the next question
  nextQuestion($event? : any): void {
    if (this.indexQuestion < this.questionList.length) {
      if (!$event && this.questionList[this.indexQuestion]) {
        this.indexQuestion++;
        this.currentStep++;
      } else {
        console.log("event: no ha respondido.");
      }

      if ($event && this.canPassToNextQuestion) {
        this.indexQuestion++;
        this.currentStep++;
      }
    } else {
      this.areResponsedAllQuestions(this.questionList) && this.currentStep++;
    }
  }

  areRespondedNextQuestion(questionList: QuestionList[]): boolean {
    return questionList[this.currentStep - 1].value ? true : false;
  }

  areResponsedAllQuestions(questionList: QuestionList[]): boolean {
    let result = true;

    for (let i = 0; i < questionList.length; i++) {
      if (questionList[i].value === null) {
        result = false;
        break;
      }
    }

    return result;
  }

  setAnswer(value: any) {
    this.questionList[this.indexQuestion].emojiSelected = value;
    this.questionList[this.indexQuestion].value = value;
    !this.isTwoQuestionsFormat && this.nextQuestion();
    this.isButtonVisible();
    this.changeDetector.detectChanges();
  }

  isButtonVisible() {
    this.questionList[1].childs[this.questionList[1].childs.length - 1].value =
      this.textAreaModel;

    // Verificar si hay tercera pregunta (solo para pacientes)
    const hasThirdQuestion = this.questionList.length > 2 && this.questionList[2];
    const thirdQuestionAnswered = hasThirdQuestion ? this.selectedRecommendOption !== null : true;

    if (this.questionList[this.indexQuestion].emojiSelected >= 4) {
      this.selectResponse = null;
      this.textAreaModel = "";
      // Si hay tercera pregunta, debe estar respondida para mostrar el botón
      this.buttonVisible = thirdQuestionAnswered;
    } else if (
      this.questionList[this.indexQuestion].emojiSelected &&
      this.questionList[this.indexQuestion].emojiSelected < 4 &&
      this.selectResponse &&
      this.selectResponse !==
        this.questionList[1].childs[this.questionList[1].childs.length - 1].id
    ) {
      this.textAreaModel = "";
      // Si hay tercera pregunta, debe estar respondida para mostrar el botón
      this.buttonVisible = thirdQuestionAnswered;
    } else if (this.textAreaModel && this.textAreaModel.length >= this.minLengthTextArea) {
      // Si hay tercera pregunta, debe estar respondida para mostrar el botón
      this.buttonVisible = thirdQuestionAnswered;
    } else {
      this.buttonVisible = false;
    }
  }

  answerFormatter(answer: any) {
    let answerFormatted: any;
    answerFormatted = {
      questionId: answer.id,
      type: answer.type,
    };
    // tslint:disable:switch-default
    switch (answer.type) {
      case this.inputType.INPUT.name:
        answerFormatted.inputValue = answer.value?.toString();
        return answerFormatted;
      case this.inputType.BOOLEAN.name:
        switch (answer.style) {
          case this.inputType.BOOLEAN.styles.thumbs:
          case this.inputType.BOOLEAN.styles.default:
          case this.inputType.BOOLEAN.styles.slider:
            answerFormatted.booleanValue = answer.value?.toString();
        }
        return answerFormatted;
      case this.inputType.RATING.name:
        switch (answer.style) {
          case this.inputType.RATING.styles.emojis:
          case this.inputType.RATING.styles.slider:
          case this.inputType.RATING.styles.stars:
          case this.inputType.RATING.styles.starts:
            answerFormatted.numericValue = answer.value.toString();
        }
        return answerFormatted;
      case this.inputType.GROUP.name:
        answer.childs.forEach((element:any) => {
          if (element.value) {
            this.preparedAnswers?.answers.push(this.answerFormatter(element));
          }
        });
        break;
    }
  }

  prepareToSend(questionList: QuestionList[]): SurveyResponse {
    // tslint:disable-next-line:prefer-const
    this.preparedAnswers = this.resetSurvey();

    for (let i = 0; i < questionList.length; i++) {
      this.preparedAnswers.answers.push(this.answerFormatter(questionList[i]));
    }
    this.preparedAnswers.answers = this.utilsService.cleanArray(
      this.preparedAnswers.answers
    );
    return this.preparedAnswers;
  }

  // Method that sends the survey
sendSurvey() {
    if (this.isTwoQuestionsFormat) {
      this.questionList[1].value = this.textAreaModel
        ? this.textAreaModel
        : ".";
    }

    if (
      this.areResponsedAllQuestions(this.questionList) ||
      this.isTwoQuestionsFormat
    ) {
      this.loading = true;
      this.apiConectateServ
        .sendSurvey(this.idSurvey, this.prepareToSend(this.questionList)).pipe(catchError(() => {this.loading = false; return throwError(() => new Error("Error sending survey"))}))
        .subscribe(() => {
          this.loading = false;
          //Reseteamos la propiedad de mostrar encuesta
          this.stateHandlerSvc.set("goToSurvey", false);
          //Para q aparezca el mensaje de agradecimiento de la encuesta
          this.stateHandlerSvc.set("surveyDone", true);
          this.stateHandlerSvc.set("intoRoomDisconnected", true);
        });
    }
  }


  back() {
    //Reseteamos la propiedad  de mostrar encuesta
    this.stateHandlerSvc.set("goToSurvey", false);
  }

  charsLimitation(chars: string) {
    const points = chars.length > 80 ? "..." : "";
    return chars.substr(0, 80 - 1) + points;
  }

  // Method that gets the survey questions
  private getSurveyQuestions() {
    const roleType = this.sessionStorageSrv.get("roomData").roleType;
//     of({
//     "content": [
//         {
//             "id": 2,
//             "title": "Opinión del asistencial sobre la vídeo consulta",
//             "description": "Opinión del asistencial sobre la vídeo consulta",
//             "timeHorizon": {
//                 "opensOn": "2025-09-14",
//                 "closesOn": "2030-09-20"
//             },
//             "questions": [
//                 {
//                     "childs": [],
//                     "id": 8,
//                     "type": "rating",
//                     "text": "Valore la visita",
//                     "warning": null,
//                     "interval": {
//                         "left": {
//                             "value": 1,
//                             "label": "malo"
//                         },
//                         "right": {
//                             "value": 5,
//                             "label": "muy bueno"
//                         }
//                     },
//                     "style": "slider",
//                     "warningNumericValue": null,
//                     "warningBooleanValue": null
//                 },
//                 {
//                     "childs": [
//                         {
//                             "childs": [],
//                             "id": 10,
//                             "type": "boolean",
//                             "text": "Baja calidad de la conexión",
//                             "warning": false,
//                             "interval": null,
//                             "style": "slider",
//                             "warningNumericValue": null,
//                             "warningBooleanValue": false
//                         },
//                         {
//                             "childs": [],
//                             "id": 11,
//                             "type": "boolean",
//                             "text": "Problemas con el acceso a la Visita",
//                             "warning": false,
//                             "interval": null,
//                             "style": "slider",
//                             "warningNumericValue": null,
//                             "warningBooleanValue": false
//                         },
//                         {
//                             "childs": [],
//                             "id": 12,
//                             "type": "boolean",
//                             "text": "Problemas con las funcionalidades de la herramienta",
//                             "warning": false,
//                             "interval": null,
//                             "style": "slider",
//                             "warningNumericValue": null,
//                             "warningBooleanValue": false
//                         },
//                         {
  //                             "childs": [],
//                             "id": 13,
//                             "type": "boolean",
//                             "text": "No es fácil de usar, ni intuitiva",
//                             "warning": false,
//                             "interval": null,
//                             "style": "slider",
//                             "warningNumericValue": null,
//                             "warningBooleanValue": false
//                         },
//                         {

//                             "childs": [],
//                             "id": 14,
//                             "type": "input",
//                             "text": "Otros",
//                             "warning": false,
//                             "interval": null,
//                             "style": "slider",
//                             "warningNumericValue": null,
//                             "warningBooleanValue": null
//                         }
//                     ],
//                     "id": 9,
//                     "type": "group",
//                     "text": "¿Qué problemas destacarías con la visita de Telemedicina?",
//                     "warning": null,
//                     "interval": null,
//                     "style": "slider",
//                     "warningNumericValue": null,
//                     "warningBooleanValue": null
//                 }
//             ],
//             "role": "HEALTH_PROFESSIONAL"
//         }
//     ],
//     "pageable": "INSTANCE",
//     "last": true,
//     "totalPages": 1,
//     "totalElements": 1,
//     "size": 1,
//     "number": 0,
//     "sort": {
//         "empty": true,
//         "sorted": false,
//         "unsorted": true
//     },
//     "first": true,
//     "numberOfElements": 1,
//     "empty": false
// }
//  )
this.apiConectateServ
  .getSurveyQuestions(true, roleType)
      .subscribe((survey: any) => {
        const questions: any[] = survey.content[0]?.questions;
        this.idSurvey = survey.content[0]?.id;

        this.steps = questions?.length;
        this.questionList = this.formatQuestions(questions ?? []);
      });
  }

  // Format the survey questions object to render the questions
  private formatQuestions(questions: any): QuestionList[] {
    const questionFormated: any = [];

    questions.forEach((question:any) => {
      let emojisTypes;

      if (question.style === this.inputType.RATING.styles.emojis) {
        emojisTypes =
          question.interval?.right.value === 5
            ? this.fiveEmojis
            : this.threeEmojis;
      }
      questionFormated.push({
        childs: question.childs,
        id: question.id,
        text: question.text,
        value: null,
        type: question.type,
        style: question.style,
        emoji: emojisTypes,
        emojiSelected: null,
        interval: question.interval,
      });
    });

    return questionFormated;
  }

  onChange(valRef:any) {
    const value = valRef.value;
    this.selectResponse = +value;
    this.questionList[1].childs.map((child) => {
      if (child.id === this.selectResponse && child.type === this.inputType.BOOLEAN.name) {
        child.value = true;
      } else {
        child.value = null;
      }
    });
    this.isButtonVisible();
  }

  onRecommendChange(option: any) {
    this.selectedRecommendOption = option.id;
    // Actualizar valores de los childs de la tercera pregunta
    this.questionList[2].childs.forEach((child: any) => {
      child.value = child.id === option.id ? true : null;
    });
    this.questionList[2].value = option.id;
    this.isButtonVisible();
  }
}
